export default (function (item) {
  return !!item.isGroupHeader;
});
//# sourceMappingURL=isGroupHeader.js.map